import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryKitchenIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-kitchen"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M10.7006 7.49909C10.7006 9.62563 8.97678 11.3495 6.85025 11.3495C4.72382 11.3495 3 9.62563 3 7.49909C3 5.37266 4.72382 3.64874 6.85025 3.64874C8.97678 3.64874 10.7006 5.37266 10.7006 7.49909Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M20.4281 7.49909C20.4281 9.62563 18.7043 11.3495 16.5778 11.3495C14.4514 11.3495 12.7275 9.62563 12.7275 7.49909C12.7275 5.37266 14.4514 3.64874 16.5778 3.64874C18.7043 3.64874 20.4281 5.37266 20.4281 7.49909Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M15.6561 6.18905C15.6561 8.50261 13.7806 10.3781 11.467 10.3781C9.15355 10.3781 7.27808 8.50261 7.27808 6.18905C7.27808 3.87548 9.15355 2 11.467 2C13.7806 2 15.6561 3.87548 15.6561 6.18905Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M15.6715 18.3575H7.26257C6.66217 18.3575 6.17554 17.8708 6.17554 17.2705V7.16052H16.7587V17.2705C16.7587 17.8708 16.272 18.3575 15.6715 18.3575Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M15.8632 21.9114H7.07112C6.57654 21.9114 6.17554 21.5105 6.17554 21.0159V19.8768C6.17554 19.4119 6.55242 19.035 7.01725 19.035H15.9169C16.3819 19.035 16.7588 19.4119 16.7588 19.8768V21.0159C16.7588 21.5105 16.3578 21.9114 15.8632 21.9114Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M9.09619 15.6093C8.90393 15.6093 8.74805 15.4534 8.74805 15.2612V12.5285C8.74805 12.3363 8.90393 12.1804 9.09619 12.1804C9.28845 12.1804 9.44433 12.3363 9.44433 12.5285V15.2612C9.44433 15.4534 9.28845 15.6093 9.09619 15.6093Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M11.5786 15.6093C11.3863 15.6093 11.2305 15.4534 11.2305 15.2612V12.5285C11.2305 12.3363 11.3863 12.1804 11.5786 12.1804C11.7709 12.1804 11.9268 12.3363 11.9268 12.5285V15.2612C11.9268 15.4534 11.7709 15.6093 11.5786 15.6093Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M13.8379 15.6093C13.6456 15.6093 13.4897 15.4534 13.4897 15.2612V12.5285C13.4897 12.3363 13.6456 12.1804 13.8379 12.1804C14.0301 12.1804 14.186 12.3363 14.186 12.5285V15.2612C14.186 15.4534 14.0301 15.6093 13.8379 15.6093Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryKitchenIcon.displayName = 'CategoryKitchenIcon';
